import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { HttpHelpersService } from '../http-helpers/http-helpers.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Response } from 'src/app/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class PendingOrdersService {

  url: string;

  constructor(
    private httpHelpers: HttpHelpersService,
    private http: HttpClient,
    private translate : TranslateService
  ) {
    this.url = this.httpHelpers.getUrl();
  }

  getAllPendings(company?): Observable<any> {
    let httpOptions = {
      ...this.httpHelpers.getHeader()
    }

    if (company) {
      httpOptions = {
        ...httpOptions, ...this.httpHelpers.setParams(
          {
            'empresa': company,
          }
        )
      }
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.get<Response>(`${this.url}/pendientes`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('pending-orders.obtener pendientes')))
      );
  }

  getPendingsByUnit({company, selectedUnitId}): Observable<any> {
    let httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.get<Response>(`${this.url}/empresas/${company}/propiedades/${selectedUnitId}/pendientes`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('pending-orders.obtener pendientes')))
      );
  }

  confirmOI({ company, selectedUnitId, requestId, oiId }, response): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }

    return this.http.post<Response>(
      `${this.url}/empresas/${company}/propiedades/${selectedUnitId}/solicitudes/${requestId}/ois/${oiId}/confirmar`, response,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers
          .errorHandler(`${response.get('confirmacion') == 1 ? this.translate.instant('pending-orders.confirmar') : this.translate.instant('pending-orders.rechazar')} ${this.translate.instant('pending-orders.visita de inspección')}`))
      );
  }

  cancelOI({ company, selectedUnitId, requestId, oiId }): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.delete<Response>(
      `${this.url}/empresas/${company}/propiedades/${selectedUnitId}/solicitudes/${requestId}/ois/${oiId}/confirmar`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('pending-orders.cancelar Visita de inspección')))
      );
  }

  confirmOT({ company, selectedUnitId, requestId, otId }, response): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.post<Response>(
      `${this.url}/empresas/${company}/propiedades/${selectedUnitId}/solicitudes/${requestId}/ots/${otId}/confirmar`, response,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers
          .errorHandler(`${response.get('confirmacion') == 1 ? this.translate.instant('pending-orders.confirmar') : this.translate.instant('pending-orders.rechazar')} ${this.translate.instant('pending-orders.agenda de trabajos')}`))
      );
  }

  cancelOT({ company, selectedUnitId, requestId, otId }): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.delete<Response>(
      `${this.url}/empresas/${company}/propiedades/${selectedUnitId}/solicitudes/${requestId}/ots/${otId}/confirmar`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('pending-orders.cancelar Agenda de trabajos')))
      );
  }
}
